import { SegmentedButton } from '@smartgift/frontend-toolkit';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { CONTACTS_TAB } from '@hero/constants';
import { useIsAutomationEnabled } from '@hero/hooks';
import { PageLayout } from '@hero/layouts';
import {
  ContactDetailAutomations,
  ContactDetailOverview,
  ContactDetailRecognitions
} from '@hero/organisms';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetContact } from '@hero/services/contact-service/hooks';

import * as S from './style';

export default function ContactDetailPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { id } = useParams();
  const isAutomationEnabled = useIsAutomationEnabled();

  const { data: contactData } = useGetContact({ id });

  useEffect(() => {
    if (contactData?.deleted || contactData === null) navigate(ROUTE_PATHS.CONTACTS);
  }, [contactData]);

  const hash = decodeURIComponent(location.hash.slice(1));
  const defaultActiveTab =
    Object.values(CONTACTS_TAB).find(o => o === hash) || CONTACTS_TAB.overview;
  const [activeTab, setActiveTab] = useState(defaultActiveTab);

  const contactOptions = [
    {
      value: CONTACTS_TAB.overview,
      label: t('overview'),
      children: <ContactDetailOverview setActiveTab={setActiveTab} />
    },
    {
      value: CONTACTS_TAB.recognitions,
      label: t('recognitions'),
      children: <ContactDetailRecognitions />
    },
    ...(isAutomationEnabled
      ? [
          {
            value: CONTACTS_TAB.automations,
            label: t('automations'),
            children: <ContactDetailAutomations />
          }
        ]
      : [])
  ];

  return (
    <PageLayout
      header={{
        title: t('contactDetails'),
        backButton: true
      }}
      navigation={{
        leftButton: {
          children: t('back'),
          onClick: () => navigate(ROUTE_PATHS.CONTACTS)
        }
      }}
    >
      <S.ContactDetailWrapper>
        <SegmentedButton
          options={contactOptions}
          isPage
          activeTab={activeTab}
          onChange={setActiveTab}
          withLine
        />
      </S.ContactDetailWrapper>
    </PageLayout>
  );
}
